<script setup lang="ts">
import { ref } from 'vue';
import SearchField from '@/components/filter/SearchField.vue';
import { I18nKey } from '@/utils/typings';
import { TaskOverviewFilterObject } from '../types';
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import { TaskTypeDescription } from '@/api/generator';

import PtwResetFilterButton from '@/components/buttons/PtwResetFilterButton.vue';

const modelValue = defineModel<TaskOverviewFilterObject>({ required: true });

const searchedFieldsI18nKeys: I18nKey[] = ['Search'];

interface CategoryItem {
  title: string;
  value: string;
}

const props = defineProps<{
  categoryItems: Array<CategoryItem>;
  targetAreaNames: Array<string>;
  taskTypeItems?: Array<{ title: string; value: TaskTypeDescription }>;
}>();

const targetAreaItems = ref(props.targetAreaNames);

function clearFilters() {
  modelValue.value = {};
}
</script>

<template>
  <v-row class="align-center mt-2 pl-2 pr-2">
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <SearchField
        v-model:modelValue="modelValue.search"
        :placeholder="
          $t('Search', {
            columns: searchedFieldsI18nKeys.map((key) => `$t(${key})`),
          })
        "
      />
    </v-col>

    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.taskType"
        :label="$t('TaskType_one')"
        :items="taskTypeItems"
        :placeholder="$t('All')"
        clearable
      ></Autocomplete>
    </v-col>

    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.taskItemAreas"
        :label="$t('TargetArea_one')"
        :items="targetAreaItems"
        :placeholder="$t('All')"
        :maxNumDisplayItems="2"
        multiple
        clearable
        chips
      ></Autocomplete>
    </v-col>

    <v-col md="3" lg="1" class="d-flex align-center justify-start pa-2">
      <PtwResetFilterButton @click="clearFilters" />
    </v-col>
  </v-row>
</template>
